import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  FileText,
  Plus,
  Volume2
} from 'lucide-react';

const DashboardPage = () => {
  const { user } = useAuth();

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-semibold text-gray-900">
          Welcome back, {user?.name}
        </h1>
        <p className="mt-1 text-sm text-gray-500">
          Create professional voice announcements quickly and easily.
        </p>
      </div>

      {/* Quick Actions */}
      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
            Quick Actions
          </h3>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <Link
              to="/submissions/new"
              className="relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-primary-500 rounded-lg border-2 border-dashed border-gray-300 hover:border-gray-400"
            >
              <div>
                <span className="rounded-lg inline-flex p-3 bg-primary-50 text-primary-600 group-hover:bg-primary-100">
                  <Plus className="h-6 w-6" />
                </span>
              </div>
              <div className="mt-4">
                <h3 className="text-lg font-medium text-gray-900">
                  Create New Announcement
                </h3>
                <p className="mt-2 text-sm text-gray-500">
                  Start creating a new voice announcement from templates or custom text.
                </p>
              </div>
            </Link>

            <Link
              to="/templates"
              className="relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-primary-500 rounded-lg border-2 border-dashed border-gray-300 hover:border-gray-400"
            >
              <div>
                <span className="rounded-lg inline-flex p-3 bg-green-50 text-green-600 group-hover:bg-green-100">
                  <FileText className="h-6 w-6" />
                </span>
              </div>
              <div className="mt-4">
                <h3 className="text-lg font-medium text-gray-900">
                  Browse Templates
                </h3>
                <p className="mt-2 text-sm text-gray-500">
                  Explore available announcement templates for different categories.
                </p>
              </div>
            </Link>

          </div>
        </div>
      </div>

      {/* Quick Start */}
      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <div className="text-center py-8">
            <Volume2 className="mx-auto h-16 w-16 text-primary-600" />
            <h3 className="mt-4 text-lg font-medium text-gray-900">Ready to Create an Announcement?</h3>
            <p className="mt-2 text-sm text-gray-500 max-w-md mx-auto">
              Choose from our professional templates or create your own custom voice announcement.
            </p>
            <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
              <Link to="/templates" className="btn btn-outline">
                <FileText className="h-4 w-4 mr-2" />
                Browse Templates
              </Link>
              <Link to="/submissions/new" className="btn btn-primary">
                <Plus className="h-4 w-4 mr-2" />
                Create Announcement
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;